import axios from 'axios';
import {getData} from '../utils/data';

export default function orderForm() {
  const main = document.getElementById('order-form');
  const cart = document.getElementById('update-cart');
  // const nonForm = document.getElementById('non-compliant-form');
  const purchaseOrder = document.getElementById('purchase-order-form');
  // const batteryAttachment = document.getElementById('battery-attachment-form');
  const loading = document.getElementById('order-loading');
  const csrf = document.querySelector('[name="CSRF_TOKEN"]');

  if (main && cart) {

    initProducts(cart);
    initWarnings();

    const mainSubmit = async (e) => {
      e.preventDefault();

      // checkWarnings(cart);
      // console.log('SUBMIT');

      loading.classList.remove('hidden');

      // checks if each section is good to continue so we can submit the order
      let cartGood = await cartForm(cart, csrf);
      // let formGood = true; // await nonFormSubmit(nonForm, csrf); // this form has been removed for now
      // let attachmentGood = await batteryAttachmentForm(batteryAttachment, csrf);   
      let purchaseGood = await purchaseOrderForm(purchaseOrder, csrf);   

      if (cartGood && purchaseGood) {
        main.removeEventListener('submit', mainSubmit);
        main.submit();
      } else {
        loading.classList.add('hidden');
      }
    };

    // add the main submit function + prevent the submits for cart and form
    main.addEventListener('submit', mainSubmit);
    // cart.addEventListener('submit', e => e.preventDefault());
    // nonForm.addEventListener('submit', e => e.preventDefault());
    // batteryAttachment.addEventListener('submit', e => e.preventDefault());
    purchaseOrder.addEventListener('submit', e => e.preventDefault());
  }

  // Limit filesize
  let attachmentInput = document.querySelector('input#orderAttachment');
  if (attachmentInput && typeof FileReader !== "undefined") {
    attachmentInput.addEventListener('change', event => {
      var size = attachmentInput.files[0].size;
      if (size > 10000000) alert('Please only attach files that are less than 10MB.');
      attachmentInput.files[0].remove;
    });
  }
}

// async function batteryAttachmentForm(form, csrf) {

//   const file = form.querySelector('#attachemnt');
//   if (file.value) {
//     const data = new FormData(form);

//     // update the cart with the attachment
//     await axios.post('/', data, {
//       headers: {
//         'X-CSRF-Token': csrf.value,
//         'Content-Type': 'multipart/form-data'
//       },
//       params: {
//         action: 'commerce/cart/update-cart',
//         CSRF_TOKEN: csrf.value,
//       }
//     });
//   }

//   return false;
// }

async function purchaseOrderForm(form, csrf) {
  const input = form.querySelector('#purchase-order');

  // if has value then update the cart/order with the purchase order number
  if (input.value) {
    const data = new FormData(form);

    // update the cart with the latest items
    await axios.post('/', data, {
      headers: {
        'X-CSRF-Token': csrf.value,
        'Content-Type': 'multipart/form-data'
      },
      params: {
        action: 'commerce/cart/update-cart',
        CSRF_TOKEN: csrf.value,
      }
    });
  }

  // we can pretty much always return true because this is optional
  return true;
}

// checks and returns if the form submission is successful
// async function nonFormSubmit(form, csrf) {

//   // removed for now

//   const product = form.querySelector('.product.border-menu-hover');

//   // if product is open then check
//   if (product) {
//     if (!form.checkValidity()) {
//       form.reportValidity();
//       return false;
//     } else {

//       // update the cart with the latest items
//       const formData = new FormData(form);
//       await axios.post('/send-non-compliant-ewaste-form', formData, {
//         headers: {
//           'X-CSRF-Token': csrf.value,
//           'Content-Type': 'multipart/form-data'
//         },
//         params: {
//           CSRF_TOKEN: csrf.value,
//         }
//       });
//     }
//   }

//   return true;
// }

// return is the cart is good to go.
async function cartForm(cart, csrf) {
  const products = cart.querySelectorAll('.product.border-menu-hover');

  if (products.length > 0) {
    // if the cart fields is valid
    if (!checkHasValuesInForm(cart, products) || !cart.checkValidity() || !await checkWarnings(
        cart)) {
      cart.reportValidity();
      return false;
    }

    // create the form data from it
    const cartData = new FormData(cart);

    // empty the cart so we don't double up on the order
    await emptyCart(csrf);

    // update the cart with the latest items
    await axios.post('/', cartData, {
      headers: {
        'X-CSRF-Token': csrf.value,
        'Content-Type': 'multipart/form-data'
      },
      params: {
        action: 'commerce/cart/update-cart',
        CSRF_TOKEN: csrf.value,
      }
    });
  }

  return true;
}

function initWarnings() {
  const warning = document.getElementById('warning-popup'),
      warningContinue = document.getElementById('warning-continue'),
      warningBack = document.getElementById('warning-back');

  warningBack.addEventListener('click', function() {
    const warningsEvent = new CustomEvent('popup-warning', {detail: false});
    warning.dispatchEvent(warningsEvent);
  });

  warningContinue.addEventListener('click', function() {
    const warningsEvent = new CustomEvent('popup-warning', {detail: true});
    warning.dispatchEvent(warningsEvent);
  });
}

async function checkWarnings(cart, products) {
  // warning container, list and buttons.
  const warning = document.getElementById('warning-popup'),
      warningList = document.getElementById('warning-list'),
      warningContinue = document.getElementById('warning-continue'),
      warningBack = document.getElementById('warning-back');

  warningList.innerHTML = ''; // clear this out

  // value to return if the form can move forward
  let isGoodToContinue = true;

  // get the products that has warnings
  let productItems = cart.querySelectorAll('.product__item[data-warnings]');

  // to display the warning popup or not
  let openWarnings = false;

  // check if the parent is open, if not then continue with checking for warnings
  productItems.forEach(el => {
    const parent = el.closest('.product');

    if (parent.classList.contains('border-menu-hover')) {
      // get the 'id' and 'text'
      const jsonArray = JSON.parse(el.getAttribute('data-warnings'));

      // get the product from the json ids and its qty field
      // check if the qty field is not empty
      // if empty, then set to display the warnings.
      jsonArray.forEach(json => {
        const productToCheck = document.getElementById('p-id-' + json.id.toString());

        if (productToCheck) {
          const productToCheckQty = productToCheck.querySelector('.product__qty');
          const value = productToCheckQty.value;
  
          // if empty then add the warning
          if (value === null || value === '' || parseInt(value) === 0) {
            openWarnings = true;
            warningList.appendChild(createWarning(json.text));
          }
        }

      });
    }
  });

  // if has warnings then open the popup
  if (openWarnings) {
    warning.classList.remove('hidden');

    // create a new promise that waits for the warning event.
    // since the two buttons can give a true or false, set that to isGoodToContinue
    // true = good to continue with the order
    // false = go back and allow the user to edit
    await (new Promise((resolve, reject) => {
      warning.addEventListener('popup-warning', function checkingForButtons(e) {
        isGoodToContinue = e.detail;
        warning.removeEventListener('popup-warning', checkingForButtons);
        warning.classList.add('hidden');
        resolve();
      });
    }));
  }

  return isGoodToContinue;
}

function createWarning(text) {
  const p = document.createElement('p');
  const textNode = document.createTextNode(text);

  p.appendChild(textNode);

  return p;
}

// check is there's values in the form
function checkHasValuesInForm(form, products) {
  products.forEach(product => {
    const inputs = product.querySelectorAll('input, select, textarea');
    let hasInput = false;

    // check if the inputs has any values at all
    inputs.forEach(el => {
      const trimmed = el.value.toString().trim();
      if (trimmed.length > 0 && trimmed !== '0' && !hasInput) {
        hasInput = true;
      }
    });

    // if open but has no input the return false
    if (!hasInput) {
      return false;
    }
  });

  return true;
}

async function emptyCart(csrf) {
  const currentCart = await axios.get('', {
    params: {
      action: 'commerce/cart/get-cart',
      CSRF_TOKEN: csrf.value
    }
  }).then((response) => {
    if (response.data.cart) {
      return response.data.cart;
    }

    return null;
  });

  if (currentCart && currentCart.lineItems.length > 0) {
    let lineItems = {};

    currentCart.lineItems.forEach(item => {
      lineItems[item.id] = {
        remove: true
      }
    });

    return axios.post('/', {
      lineItems: lineItems,
    }, {
      headers: {
        'X-CSRF-Token': csrf.value
      },
      params: {
        action: 'commerce/cart/update-cart',
        CSRF_TOKEN: csrf.value,
      }
    }).then(response => {
      return response.data;
    });
  }
}

function initProducts(cart) {
  // on init, set up the product toggling functions
  const products = [...cart.querySelectorAll('.product')];

  // product is open == 'border-menu-hover'
  products.forEach(product => {
    const productItems = [...product.querySelectorAll('.product__items')];
    const productItem = [...product.querySelectorAll('.product__item')];

    setupProductToggle(cart, product, productItems);
    productItem.forEach(item => setupQtyFields(item));
  });

}

function setupProductToggle(cart, product, productItems) {
  // on toggle if it is closed then remove any required to false and reset the form.
  productItems.forEach(item => {
    const toggler = getData(item, 'toggler');
    const confirmField = item.querySelector('.product__confirm');

    toggler.on('toggle', (e) => {
      // if it is open
      if (!product.classList.contains('border-menu-hover')) {
        confirmField.required = false;

        if (product.dataset.productSlug === 'batteries') {
          
          // make the attachment field optional
          document.querySelector('input#orderAttachment').removeAttribute('required');
        }

        // cart.reset();
      } else {

        // make the attachment field required
        if (product.dataset.productSlug === 'batteries') {
          document.querySelector('input#orderAttachment').setAttribute('required', '');
        }
      }
    });
  });
}

function setupQtyFields(product) {
  const confirm = product.querySelector('.product__confirm');
  const qty = product.querySelector('.product__qty');

  let min = null;
  let oldValue = qty.value;

  if (qty.getAttribute('data-min')) {
    min = parseInt(qty.getAttribute('data-min'));
  }

  if (confirm) {
    // have to manually check so we the user can set it to 0
    qty.addEventListener('change', (e) => {
      if (min) {
        // if it's an increase
        let currentValue = e.target.value;
        if (oldValue < currentValue) {
          if (currentValue < min) {
            e.target.value = min;
          }
        } else {
          if (currentValue < min) {
            e.target.value = 0;
          }
        }

        oldValue = e.target.value;
      }

      confirm.required = e.target.value > 0;
    });
  }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/order-form.js